<template>
  <div class="d-flex flex-column gap16" :class="{'mb80': this.$store.state.resize.w < 768}">
    <div>
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.1') }}
      </label>
      <InputSimple
        id='proffer'
        :numOnly="true"
        :regCheck="profferRegCheck"
        :placeholder="$t('components.service.modal.p2p.SwapsFilters.10')"
        :dataValue='this.fields.proffer'
        @updateParentState="this.updateState"
        class="w-100"
        :icon="'hashtag'"
      />
    </div>
    <div v-if="!this.isAdmin">
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.2') }}
      </label>
      <InputSimple
        id='uid'
        :placeholder="$t('components.service.modal.p2p.SwapsFilters.11')"
        :dataValue='this.fields.uid'
        @updateParentState="this.updateState"
        class="w-100"
        :icon="'user'"
        :iconColor="{ 0: '#808080', 1: '#808080' }"
      />
    </div>
    <div v-if="this.isAdmin">
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.3') }}
      </label>
      <InputSimple
        id='maker'
        :placeholder="$t('components.service.modal.p2p.SwapsFilters.12')"
        :dataValue='this.fields.maker' 
        @updateParentState="this.updateState"
        class="w-100"
        key=""
        :icon="'user'"
        :iconColor="{ 0: '#808080', 1: '#808080' }"
      />
    </div>
    <div v-if="this.isAdmin">
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.4') }}
      </label>
      <InputSimple
        id='taker'
        :placeholder="$t('components.service.modal.p2p.SwapsFilters.13')"
        :dataValue='this.fields.taker'
        @updateParentState="this.updateState"
        class="w-100"
        :icon="'user'"
        :iconColor="{ 0: '#808080', 1: '#808080' }"
      />
    </div>
    <div>
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.5') }}
      </label>
      <SelectSimple
        id='status'
        :dataValue='this.fields.status' 
        @updateParentState="this.updateState" 
        :keywords.sync='this.keywords1'
        :defaultValue="$t('components.service.modal.p2p.SwapsFilters.16')"
        :isFilterSelect="true"
        :hotUpdate="true"
        class="w-100"
        :icon="'info'"
        :iconColor="{ 0: '#808080', 1: '#808080' }"
      />
    </div>
    <div>
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.6') }}
      </label>
      <CustomSelectButton
        class="lh20 w-100 mb8"
        v-model="fields.give_type"
        :options="[
          { label: $t('components.service.modal.p2p.SwapsFilters.18'), value: 'internal' },
          { label: $t('components.service.modal.p2p.SwapsFilters.19'), value: 'external' }
        ]"
        @update:modelValue="onGiveTypeChange"
      />
      <div class="d-flex gap8 align-items-center" :class="{'flex-column': this.$store.state.resize.w < 768}">
        <InputSimple
          id='summ_give'
          :numOnly="true"
          :placeholder="$t('components.service.modal.p2p.SwapsFilters.14')"
          :dataValue='this.fields.summ_give'
          @updateParentState="this.updateState"
          class="flex-grow-1"
          :icon="'banknote'"
        />
        <SelectSimple
          v-if="fields.give_type === 'internal'"
          id='internal_curr'
          :dataValue='this.fields.internal_curr' 
          :isSearch="true" 
          @updateParentState="this.updateState" 
          :keywords.sync='this.curr_list_internal' 
          :hotUpdate="true"
          :currsP2P="fields.give_type"
          :isFilterSelect="true"
          :defaultValue="$t('components.service.modal.p2p.SwapsFilters.17')"
          class="w-100"
        />
        <SelectSimple
          v-else
          id='external_type'
          :dataValue='this.fields.external_type' 
          :isSearch="true" 
          @updateParentState="this.updateState" 
          :keywords.sync='this.curr_list_external' 
          :hotUpdate="true"
          :currsP2P="fields.give_type"
          :isFilterSelect="true"
          :defaultValue="$t('components.service.modal.p2p.SwapsFilters.17')"
          class="w-100"
        />
      </div>
    </div>
    <div>
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.7') }}
      </label>
      <CustomSelectButton
        class="lh20 w-100 mb8"
        v-model="fields.get_type"
        :options="[
          { label: $t('components.service.modal.p2p.SwapsFilters.18'), value: 'internal' },
          { label: $t('components.service.modal.p2p.SwapsFilters.19'), value: 'external' }
        ]"
        @update:modelValue="onGetTypeChange"
      />
      <div class="d-flex gap-2 align-items-center" :class="{'flex-column': this.$store.state.resize.w < 768}">
        <InputSimple
          id='summ_recive'
          :numOnly="true"
          :placeholder="$t('components.service.modal.p2p.SwapsFilters.15')"
          :dataValue='this.fields.summ_recive'
          @updateParentState="this.updateState"
          class="flex-grow-1"
          :icon="'banknote'"
        />
        <SelectSimple
          v-if="fields.get_type === 'internal'"
          id='internal_curr'
          :dataValue='this.fields.internal_curr' 
          :isSearch="true" 
          @updateParentState="this.updateState" 
          :keywords.sync='this.curr_list_internal' 
          :hotUpdate="true"
          :currsP2P="fields.get_type"
          :isFilterSelect="true"
          :defaultValue="$t('components.service.modal.p2p.SwapsFilters.17')"
          class="w-100"
        />
        <SelectSimple
          v-else
          id='external_type'
          :dataValue='this.fields.external_type' 
          :isSearch="true" 
          @updateParentState="this.updateState" 
          :keywords.sync='this.curr_list_external' 
          :hotUpdate="true"
          :currsP2P="fields.get_type"
          :isFilterSelect="true"
          :defaultValue="$t('components.service.modal.p2p.SwapsFilters.17')"
          class="w-100"
        />
      </div>
    </div>
    <div>
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.8') }}
      </label>
      <SelectSimple
        id='external_curr'
        :dataValue='this.fields.external_curr' 
        :isSearch="true" 
        @updateParentState="this.updateState" 
        :keywords.sync='this.curr_list_internal' 
        :hotUpdate="true"
        :defaultValue="$t('components.service.modal.p2p.SwapsFilters.17')"
        :isFilterSelect="true"
        :currsP2P="'internal'"
        class="w-100"
        :icon="'coins-pair'"
        :iconColor="{ 0: '#808080', 1: '#808080', 2: '#808080', 3: '#808080' }"
      />
    </div>
    <div>
      <label class="fsp14 neue-roman text-black mb8 d-block">
        {{ $t('components.service.modal.p2p.SwapsFilters.9') }}
      </label>
      <CustomSelectButton
        class="lh20 w-100"
        v-model="this.fields.role"
        :options="[
          {label: this.$t('components.service.modal.p2p.SwapsFilters.20'), value: 'all'},
          {label: this.$t('components.service.modal.p2p.SwapsFilters.3'), value: 'Maker'},
          {label: this.$t('components.service.modal.p2p.SwapsFilters.4'), value: 'Taker'}
        ]"
        @update:modelValue="onRoleChange"
      />
    </div>
  </div>
</template>

<script>
import SelectSimple from '@/components/service/SelectSimple'
import InputSimple from '@/components/service/InputSimple'
import CustomSelectButton from '@/components/service/CustomSelectButton'

export default {
  name: 'SwapsFilters',
  components: {
    SelectSimple,
    InputSimple,
    CustomSelectButton
  },
  props: {
    initialFilters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      curr_list_internal: [],
      curr_list_external: [],
      external_curr: [],
      keywords1: [],
      profferRegCheck: {
        f: (value) => {
          return value.replace(/\./g, '');
        }
      },
      fields: {
        proffer: '',
        status: '-1',
        summ_give: '',
        summ_recive: '',
        external_type: '-1',
        external_curr: '',
        internal_curr: '',
        role: 'all',
        uid: '',
        maker_uid: '',
        taker_uid: '',
        give_type: 'internal',
        get_type: 'external'
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.userData.role === 'admin';
    },
    isUidCorrect() {
      return this.fields.uid === '' || /^\d+$/.test(this.fields.uid);
    }
  },
  created() {
    this.axios.post('GetKeywords', {group: '170'}).then(res => {this.keywords1 = res.data.body});
    this.getCurrs();
    
    console.log('this.fields.role', this.fields.role);
    if (this.initialFilters && Object.keys(this.initialFilters).length > 0) {
      this.fields = { ...this.fields, ...this.initialFilters };
    }

    console.log('this.fields', this.fields);
  },
  watch: {
    initialFilters: {
      handler(newFilters) {
        if (newFilters && Object.keys(newFilters).length > 0) {
          console.log('SwapsFilters watch initialFilters:', newFilters);
          this.fields = { ...this.fields, ...newFilters };
        }
      },
      immediate: true,
      deep: true
    },
    curr_list_internal: {
      handler(newList) {
        if (newList.length > 0 && this.initialFilters && Object.keys(this.initialFilters).length > 0) {
          this.fields = { ...this.fields, ...this.initialFilters };
        }
      },
      immediate: false
    }
  },
  methods: {
    updateState(state) {
      console.log('SwapsFilters updateState:', state);
      this.fields[state.id] = state.value;
      // НЕ эмитим filterUpdate - изменения только локальные
    },
    onGiveTypeChange(value) {
      this.fields.give_type = value;
      this.fields.get_type = value === 'internal' ? 'external' : 'internal';
      this.fields.internal_curr = '';
      this.fields.external_curr = '';
      // НЕ эмитим filterUpdate - изменения только локальные
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    onGetTypeChange(value) {
      this.fields.get_type = value;
      this.fields.give_type = value === 'internal' ? 'external' : 'internal';
      this.fields.internal_curr = '';
      this.fields.external_curr = '';
      // НЕ эмитим filterUpdate - изменения только локальные
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    onRoleChange(value) {
      this.fields.role = value;
      // НЕ эмитим filterUpdate - изменения только локальные
    },
    getCurrs() {
      this.axios.post('GetlistExterlanTypes').then(res => {
          let l = res.data.body.curr_lists;
          if(l.length != 0) {
              l.forEach(e => {
                  e['value'] = e.full_name;         
              });
          }
          this.curr_list_internal = [...l];
          
          let ex = res.data.body.external_types.tables[0].colvalues;
          if(ex.length != 0) {
              ex.forEach(e => {
                  e['value'] = e.name;         
              });
          }
          this.curr_list_external = [...ex];
          this.external_curr = [...ex];

      });
    },
    clearFilters() {
      this.fields = {
        proffer: '',
        status: '-1',
        summ_give: '',
        summ_recive: '',
        external_type: '-1',
        external_curr: '',
        internal_curr: '',
        role: 'all',
        uid: '',
        maker_uid: '',
        taker_uid: '',
        give_type: 'internal',
        get_type: 'external'
      };
      // НЕ эмитим filterUpdate - изменения только локальные
    },
    applyFilters() {
      // Эмитим текущие фильтры при применении
      this.$emit('filterUpdate', this.fields);
    }
  }
}
</script>
